import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../environment.service';

@Injectable({
  providedIn: 'root'
})
export class AttendanceRegularizationService {
  apiBaseURL!: string;
  constructor(environmentService: EnvironmentService,
    private readonly http: HttpClient
  ) {
    this.apiBaseURL = environmentService.getApiEndpoint()
  }

  createRegularization(formData: any): Observable<any> {
    return this.http.post<any>(this.apiBaseURL + 'attendance-regularization', formData)
  }
  updateRegularization(formData: any, id: any): Observable<any> {
    return this.http.put<any>(this.apiBaseURL + 'attendance-regularization/' + id, formData)
  }
  approveOrRejectRegularization(formData: any, id: any): Observable<any> {
    return this.http.put<any>(this.apiBaseURL + 'attendance-regularization/approveOrReject/' + id, formData)
  }
  getRegularizationDataById(id: any): Observable<any> {
    return this.http.get<any>(this.apiBaseURL + 'attendance-regularization/' + id)
  }
  getRegularizationListWithPagi(params: {}): Observable<any> {
    let options = {
      params: new HttpParams({ fromObject: params })
    }
    return this.http.get<any>(this.apiBaseURL + 'attendance-regularization', options)
  }
  getRegularizationApproveListWithPagi(params: {}): Observable<any> {
    let options = {
      params: new HttpParams({ fromObject: params })
    }
    return this.http.get<any>(this.apiBaseURL + 'attendance-regularization/getApproverList', options)
  }
  getApprovedRegularizationList(params: {}): Observable<any> {
    let options = {
      params: new HttpParams({ fromObject: params })
    }
    return this.http.get<any>(this.apiBaseURL + 'attendance-regularization/getEmployeeLeaveRequests', options)
  }

}
